import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import Link from '../../helpers/Link';

class WebinarSubscribed extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
            show: false
        };
    }

    componentWillMount() {
        if (typeof this.props.query.webinar !== 'undefined' && this.props.query.webinar === 'subscribed') {
            this.setState({ show: true, open: true });
        }
    }

    componentWillReceiveProps(nextProps) {
        if (typeof nextProps.query.webinar !== 'undefined' && nextProps.query.webinar === 'subscribed') {
            this.setState({ show: true, open: true });
        } else {
            this.setState({ open: false }, () => {
                setTimeout(() => this.setState({ show: false }), 550);
            });
        }
    }

    render() {
        const { open, show } = this.state;
        if (open === false && show === false) {
            return null;
        }

        const {
            t, openPage, language, page, subpage
        } = this.props;
        const downloadClassName = cx('container-webinar-subscribed', {
            open: this.state.open
        });

        return (
            <div className={ downloadClassName } id="container-webinar-subscribed">
                <div className="layout">
                    <div className="page-webinar-subscribed" id="page-webinar-subscribed">
                        <div
                          className="webinar-subscribed-text"
                          id="webinar-subscribed-text"
                          dangerouslySetInnerHTML={ { __html: t('webinar.subscribed.text') } }
                        />
                        <Link
                          openPage={ openPage }
                          language={ language }
                          page={ page }
                          subpage={ subpage }
                          className="webinar-subscribed-close"
                          id="webinar-subscribed-close"
                        >
                            <span className="line-1" id="webinar-subscribed-line-1"/>
                            <span className="line-2" id="webinar-subscribed-line-2"/>
                        </Link>
                    </div>
                </div>
            </div>
        );
    }
}

WebinarSubscribed.defaultProps = {
    subpage: null,
    query: {}
};

WebinarSubscribed.propTypes = {
    t: PropTypes.func.isRequired,
    openPage: PropTypes.func.isRequired,
    language: PropTypes.string.isRequired,
    page: PropTypes.string.isRequired,
    subpage: PropTypes.string,
    query: PropTypes.objectOf(PropTypes.string)
};

export default WebinarSubscribed;



// WEBPACK FOOTER //
// ./src/components/content/webinar/WebinarSubscribed.jsx